import { render, staticRenderFns } from "./ImporterGeneral.vue?vue&type=template&id=8b813ade"
import script from "./ImporterGeneral.vue?vue&type=script&lang=js"
export * from "./ImporterGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports